'use strict';

class GeneralLedgerSettings {
  constructor(generalLedgerService, I18N, Notification) {
    this.generalLedgerService = generalLedgerService;
    this.I18N = I18N;
    this.Notification = Notification;
  }

  $onInit() {
    this.settings = {
      salesLedger: [],
      salesLedgerAccountNo: null,
      salesAccountPerProduct: false
    };
    this.i18n = {
      DUNNING_FEE: 'Purregebyr',
      INTEREST: 'Forsinkelsesrente',
      BANK: 'Bank',
      LOSS: 'Tapt fordring',
      DUNNING_FEE_CANCELLATION: 'Tapt purregebyr',
      INTEREST_LOSS: 'Tapt rentefordring',
      CURRENCY_GAIN: 'Valutagevinst',
      CURRENCY_LOSS: 'Valutatap',
      EXCHANGE_FEE: 'Vekslingsgebyr',
      SALES: 'Salg'
    };

    this.load();
  }

  load() {
    this.generalLedgerService.get()
      .then((resp) => {
        this.settings = resp.data;
      });
  }

  save() {
    this.generalLedgerService.save(this.settings)
      .then(() => {
        this.load();
        this.Notification.success(this.I18N.user.saved);
      });
  }
}

GeneralLedgerSettings.$inject = ['generalLedgerService', 'I18N', 'Notification'];

const generalLedgerSettings = {
  controller: GeneralLedgerSettings,
  template: `
    <h2>Regnskap</h2>

    <account-tabs active-tab="accounting"></account-tabs>

    <fieldset>
      <p>Disse innstilingene er ment for regnskapsføreren din. Vi anbefaler å gi regnskapsføreren din tilgang til kontoen din for å tilpasse innstillingene.</p>
      <p>For å gi regnskapsføreren din tilgang går du til fanen som heter "Tilgang" og sender dem en invitasjon på e-post.</p>
    </fieldset>

    <form ng-submit="$ctrl.save()" novalidate>

      <fieldset>
        <h3 class="subheader">Kontoplan</h3>

        <p>Kontoplan kan defineres for å eksportere data til de fleste regnskapssystemer via vår partner <a href="https://iizy.no/" target="_blank" rel="nofollow">iizy</a>. Kontoplanen har foreløpig ingen annen virkning i SendRegning.</p>

        <div class="row">
          <div class="large-4 columns">
            <label for="salesLedgerAccountNo" class="right inline">Kundefordringer</label>
          </div>
          <div class="large-6 pull-2 columns">
            <input type="number" id="salesLedgerAccountNo" name="salesLedgerAccountNo" ng-model="$ctrl.settings.salesLedgerAccountNo" placeholder="1500" min="0" />
          </div>
        </div>

        <div class="row" ng-repeat="option in $ctrl.settings.salesLedger">
          <div class="large-4 columns">
            <label for="{{ option.type }}" class="right inline">{{ $ctrl.i18n[option.type] }}</label>
          </div>
          <div class="large-6 pull-2 columns">
            <input type="number" id="{{ option.type }}" name="{{ option.type }}" ng-model="option.accountNo" min="0" />
          </div>
        </div>

        <div class="row">
          <div class="push-4 large-6 pull-2 columns">
            <label for="salesAccountPerProduct" class="">
              <input type="checkbox" id="salesAccountPerProduct" name="salesAccountPerProduct" ng-model="$ctrl.settings.salesAccountPerProduct"> Separat salgskonto per produkt
            </label>
            <small>Defineres i produktlisten hvis det er skrudd på.</small>
          </div>
        </div>

      </fieldset>

      <button type="submit" class="button">Lagre endringer</button>
    </form>
  `
};

angular
  .module('SendRegning')
  .component('generalLedgerSettings', generalLedgerSettings)
  .config(($routeProvider) => {
    $routeProvider
      .when('/konto/regnskap', {
        title: 'Regnskap',
        template: '<general-ledger-settings />',
        secure: true
      });
  });
